module.exports = __webpack_public_path__ + "static/media/WooCommerce_logo_revert.44663d9b.svg";